//import '../css/App.css';
import * as React from "react";

const About = () => {
  const [loading, setLoading] = React.useState(true);

  const MyLoader = () => (
    <svg
      className="loader"
      version="1.1"
      id="L5"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      enableBackground="new 0 0 0 0"
    >
      <circle fill="gray" stroke="none" cx="6" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 15 ; 0 -15; 0 15"
          repeatCount="indefinite"
          begin="0.1"
        />
      </circle>
      <circle fill="gray" stroke="none" cx="30" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 10 ; 0 -10; 0 10"
          repeatCount="indefinite"
          begin="0.2"
        />
      </circle>
      <circle fill="gray" stroke="none" cx="54" cy="50" r="6">
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 5 ; 0 -5; 0 5"
          repeatCount="indefinite"
          begin="0.3"
        />
      </circle>
    </svg>
  );

  React.useEffect(() => {
    setLoading(false);
  }, []);

  // return components
  return (
    <>
      {loading ? (
        MyLoader()
      ) : (
        <>
          <header className="App-header">
            <div className="about-section">
              <div className="about-sub">
                <b>What is this?</b> Good question. It actually started out as a
                sandbox project for me to refresh some skills and learn some new
                tools. I wanted to create something in AWS that was fully
                automated (aside from the IaC; will get to that) in a way that a
                Git merge would deploy the application. Along the way, I
                included a few NPM projects to make the UI more intuitive and
                easy to use. I customized some components of Linkify and Google
                Maps to my liking. Overwall the goal was achieved in brushing up
                on coding capabilities and learning along the way.
              </div>
              <div className="about-sub">
                <b>Where to go from here?</b> I see many use cases for this type
                of application: group chats, garage sales, farmers markets,
                scavender hunts, POI marking, keeping memories, hunting &
                fishing... Just about anything you can think of that would make
                use of a real-time chat / information sharing with geolocation
                built in.
              </div>
              <div className="about-sub">
                <b>What other enhancements are planned?</b> Right now, I have a
                Google sign in option. I hope to add more options for other ID
                services to make use easier and then do away with the
                unauthorized usage (maybe). I hope to add at minimum the ability
                to add photos to comments/markers. Role based features assigned
                to posts that are owned by the user and an admin. Ultimately, I
                would like to be able to easily automate the creation of a new
                "space" on demand for people to create their own.
              </div>
              <div className="about-sub">
                <b>Why?</b> For fun and educational purposes mostly. Now that I
                see potential for real world use, I might clean it up for open
                source or pitch the idea. Time will tell.
              </div>
              <div className="about-sub" id="versions">
                <b>Beta Versions</b>
                <p>
                  <br />
                  v0.9.1:
                  <br />
                  - Changed input box color
                  <br />
                  - Included Markdown input, not completely functional yet
                  <br />
                  - Fixed loader pause on full page load when waiting on Map to
                  render
                  <br />
                  <br />
                  v0.9.0:
                  <br />
                  - Bug fixes
                  <br />
                  - Finished daylight circle
                  <br />
                  - Added "Bugs" page for reporting issues and tracking
                  <br />
                  <br />
                  v0.8.6:
                  <br />
                  - Updated sunrise/sunset progress circle on bottom left
                  (weather bar)
                  <br />
                  <br />
                  v0.8.5:
                  <br />
                  - Update to remove image on send
                  <br />
                  - Remove duplicate cancel button on image removal
                  <br />
                  <br />
                  v0.8.4:
                  <br />
                  - Added username/handle to login info based on logon type
                  <br />
                  - Added icons to post menu
                  <br />
                  - Added enter keypress to send message
                  <br />
                  - Bug fixes
                  <br />
                  <br />
                  v0.8.3:
                  <br />
                  - Added scroll to bottom button popup
                  <br />
                  <br />
                  v0.8.2:
                  <br />
                  - Added auth user info to posts
                  <br />
                  - Fetched new post values for auth users
                  <br />
                  - Styled user info better in sidebar and on-click user
                  <br />
                  <br />
                  v0.8.1:
                  <br />
                  - Cached user info for page re-load - Added GitHub Login
                  option <br />
                  - Created backend server in AWS to handle authentication
                  callbacks
                  <br />
                  - Created Certbot certificate for SSL auth handling
                  <br />
                  - Enabled anonymous posting (might disable when more login
                  options are added)
                  <br />
                  <br />
                  v0.8:
                  <br />
                  - Added Google Login option <br />
                  - changed L&F of messages
                  <br />
                  - changed to flex display for many items <br />
                  - bug fixes
                  <br />
                  <br />
                  v0.7: <br />
                  - Bug Fixes
                  <br />
                  - Feature to zoom and view chat images
                  <br />
                  <br />
                  v0.6: <br />
                  - Bug Fixes
                  <br />
                  - Added functionality to attach images to post messages.
                  <br />
                  <br />
                  v0.5:
                  <br />
                  - Original version. First relatively stable version.
                  <br />
                </p>
              </div>
              <div className="about-footer">
                ©️ 2024 Chace Prochazka - DesignsByChace.com
              </div>
            </div>
          </header>
        </>
      )}
    </>
  );
};

export default About;
